export const userReviews = [
  {
    id: 1,
    name: '小雨',
    role: '韩漫资深读者',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20anime%20style%20girl%20avatar%20portrait%2C%20warm%20smile%2C%20pastel%20hair%2C%20simple%20clean%20background%2C%20cute%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    title: '最好的韩漫阅读平台',
    content: '在这里追完了《我独自升级》全集，画质清晰，更新速度也很快。分类找漫画特别方便，推荐给了好多朋友！',
  },
  {
    id: 2,
    name: '星辰大海',
    role: '漫画爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20man%20avatar%20portrait%2C%20friendly%20expression%2C%20dark%20hair%2C%20simple%20minimal%20background%2C%20clean%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    title: '资源丰富，每天都在追',
    content: '韩漫资源真的很全，从经典到新番都有。而且网站设计简洁大方，阅读体验很舒适，没有乱七八糟的广告干扰。',
  },
  {
    id: 3,
    name: '喵小咪',
    role: '恋爱漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20cat%20ears%20headband%2C%20pink%20hair%2C%20bright%20smile%2C%20kawaii%20aesthetic%2C%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    title: '恋爱漫爱好者天堂',
    content: '作为一个恋爱漫画重度爱好者，这里的分类和推荐太精准了！《女神降临》《某天成为公主》都是在这里发现的宝藏作品。',
  },
  {
    id: 4,
    name: '剑心',
    role: '热血漫忠实粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20with%20cool%20expression%2C%20short%20silver%20hair%2C%20sharp%20eyes%2C%20simple%20dark%20background%2C%20minimal%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 4,
    title: '动作漫画更新及时',
    content: '《剑尊归来》每次更新这里都能第一时间看到，翻译质量也很不错。希望以后能增加更多讨论互动功能就更完美了。',
  },
  {
    id: 5,
    name: '夜雨寄北',
    role: '奇幻题材控',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20with%20glasses%2C%20intellectual%20look%2C%20dark%20long%20hair%2C%20mysterious%20vibe%2C%20simple%20background%2C%20clean%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    rating: 5,
    title: '发现无数宝藏漫画',
    content: '从《全知读者视角》入坑，然后一发不可收拾。网站的推荐算法很准，总能给我推荐到合口味的作品，每天都要上来刷一遍。',
  },
  {
    id: 6,
    name: '清风徐来',
    role: '漫画博主',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20with%20gentle%20smile%2C%20brown%20hair%2C%20warm%20expression%2C%20simple%20light%20background%2C%20friendly%20vibe&width=80&height=80&seq=avatar-06&orientation=squarish',
    rating: 5,
    title: '专业靠谱的漫画平台',
    content: '作为漫画博主，我试过很多平台。韩漫网的分类体系和更新速度在业内绝对是顶尖水平，强烈推荐给所有韩漫同好。',
  },
];

export const stats = [
  { value: '50万+', label: '日活跃用户' },
  { value: '3000+', label: '漫画资源' },
  { value: '98%', label: '用户好评率' },
  { value: '12万+', label: '每日阅读量' },
];